import {
  availableLocalizations as localizationsConst,
  useLocale,
  isValidLocalization,
} from '../lang/LocalizationProvider';

import styles from './LocalizationSelect.module.scss';

const localeToLabel = {
  [localizationsConst.ENGLISH]: 'English',
  [localizationsConst.UKRAINIAN]: 'Українська',
  [localizationsConst.GERMAN]: 'Deutsch',
  [localizationsConst.FRENCH]: 'Français',
  [localizationsConst.SPANISH]: 'Español',
  [localizationsConst.PORTUGESE]: 'Português',
};

const LocalizationSelect = ({ className = '' }) => {
  const { selectedLocalization, availableLocalizations, changeLocalization } = useLocale();

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;

    if (isValidLocalization(newValue)) {
      changeLocalization(newValue);
    }
  };

  return (
    <label className={`${styles.label} ${className}`}>
      {localeToLabel[selectedLocalization]}
      <img className={styles.arrow} src="/images/localization/dropdown-arrow.svg" width="24" height="24" alt="" />

      <select
        name="Localization"
        id="localization-select"
        value={selectedLocalization}
        className={styles.select}
        onChange={onChange}
      >
        {availableLocalizations.map((locale) => (
          <option value={locale} key={locale}>
            {localeToLabel[locale]}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LocalizationSelect;
